import { ConductorOneChildActive, Router } from "@frui.ts/screens";
import { Modules } from "config";
import LocalizationService from "services/localizationService";
import { computed } from "mobx";
import BankTransferListViewModel from "./bankTransfers/bankTransferListViewModel";
import CardReturnListViewModel from "./cardReturns/cardReturnListViewModel";
import InternalTransfersListViewModel from "./internalTransfers/internalTransfersListViewModel";
import DistributorRefundExportsListViewModel from "./distributorRefundExports/distributorRefundExportsListViewModel";

const navigationName = "bank-exports";

@Router.registerRoute({
  name: Router.Self,
  route: navigationName,
  children: [
    BankTransferListViewModel,
    CardReturnListViewModel,
    InternalTransfersListViewModel,
    DistributorRefundExportsListViewModel,
  ],
})
export default class BankExportViewModel extends ConductorOneChildActive<
  // tslint:disable-next-line:max-union-size
  BankTransferListViewModel | CardReturnListViewModel | InternalTransfersListViewModel | DistributorRefundExportsListViewModel
> {
  constructor(
    private bankTransferListViewModel: BankTransferListViewModel,
    private cardExportListViewModel: CardReturnListViewModel,
    private internalTransferListViewModel: InternalTransfersListViewModel,
    private distributorRefundExportsListViewmModel: DistributorRefundExportsListViewModel,
    protected localizationService: LocalizationService
  ) {
    super();
    this.navigationName = navigationName;

    this.children.push(
      this.bankTransferListViewModel,
      this.cardExportListViewModel,
      this.internalTransferListViewModel,
      this.distributorRefundExportsListViewmModel
    );
  }

  protected onInitialize(): Promise<any> | void {
    this.tryActivateChild(this.children[0]);
    return super.onInitialize();
  }

  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.finance, `bankExports.${code}`, size);
  }

  @computed
  get name() {
    return this.translate("name");
  }
}
